import { LOCAL_STORAGE_KEYS } from "@consts";
import { set as vueSet } from "vue";

export const state = () => ({
	results: {
		0: 0,
		"1-3": 0,
		"4-6": 0,
		"7-9": 0,
		"10+": 0,
	},
});

export const mutations = {
	updateStats(state, payload) {
		let key;
		if (payload === 0) {
			key = "0";
		} else if (payload <= 3) {
			key = "1-3";
		} else if (payload <= 6) {
			key = "4-6";
		} else if (payload <= 9) {
			key = "7-9";
		} else {
			key = "10+";
		}
		vueSet(state.results, key, state.results[key] + 1);

		// Persist the latest stats in the local storage
		if (process.client) {
			localStorage.setItem(
				LOCAL_STORAGE_KEYS.PRMD_STATS,
				JSON.stringify(state.results)
			);
		}
	},
	resetStats(state, payload) {
		vueSet(state, "results", payload);
	},
};

export const actions = {
	SET_STATS({ commit, rootGetters }) {
		const isPreviousPuzzle = rootGetters["navigation/isFormerDatePirmyd"];

		// If the user is solving a pyramid that was already played, don't count result for the statistics
		if (isPreviousPuzzle) {
			return;
		}

		// Flag today's pirmyd as finished in local storage in case the user
		// reloads the page — see pyramid/RESTORE_SAVED_PYRAMID_INFO.
		if (process.client) {
			localStorage.setItem(
				LOCAL_STORAGE_KEYS.PRMD_SOLVED,
				JSON.stringify(true)
			);
		}

		commit("updateStats", rootGetters["input/getNumberOfExtraTries"]);
	},
	// Logs the date of whichever puzzle was just solved (today's, or a past
	// one played from the date picker) so "Random Day" can avoid re-serving
	// it. Unlike SET_STATS, this runs for BOTH today's and past puzzles.
	RECORD_SOLVED_DATE({ rootState }) {
		if (!process.client) {
			return;
		}

		const solvedDate = rootState.pyramid.currentDate;

		if (!solvedDate) {
			return;
		}

		let solvedDates = [];

		try {
			solvedDates =
				JSON.parse(
					localStorage.getItem(LOCAL_STORAGE_KEYS.PIRMYD_SOLVED_DATES)
				) || [];
		} catch (error) {
			solvedDates = [];
		}

		if (!solvedDates.includes(solvedDate)) {
			solvedDates.push(solvedDate);
			localStorage.setItem(
				LOCAL_STORAGE_KEYS.PIRMYD_SOLVED_DATES,
				JSON.stringify(solvedDates)
			);
		}
	},
};
